import { ActionIcon, Group, Stack, Text } from '@mantine/core'
import { IconFile, IconFileTypePdf, IconTrash } from '@tabler/icons-react'

type FileAttachment = {
  id: number
  downloadUrl?: string | null
  mimeType?: string
  filename?: string
}

interface AttachmentFileLinksProps<T extends FileAttachment> {
  files: T[]
  color?: string
  onDelete?: (file: T) => void
}

// Files open in a new tab so the device's own viewer handles them: a PDF gets
// full resolution, every page and pinch zoom there.
export function AttachmentFileLinks<T extends FileAttachment>({
  files,
  color = 'blue',
  onDelete,
}: AttachmentFileLinksProps<T>) {
  if (!files.length) return null

  // color may carry a shade for the text (orange.8); the icon keeps shade 6.
  const iconColor = `var(--mantine-color-${color.split('.')[0]}-6)`

  return (
    <Stack gap="xs">
      {files.map((file) => (
        <Group key={file.id} gap="sm" wrap="nowrap">
          {file.mimeType === 'application/pdf' ? (
            <IconFileTypePdf size={20} color={iconColor} />
          ) : (
            <IconFile size={20} color={iconColor} />
          )}
          <Text
            component="a"
            href={file.downloadUrl ?? undefined}
            target="_blank"
            rel="noreferrer"
            size="sm"
            c={color}
            td="underline"
            style={{ flex: 1, wordBreak: 'break-all' }}
          >
            {file.filename ?? 'Liite'}
          </Text>
          {onDelete && (
            <ActionIcon
              variant="subtle"
              color="red"
              onClick={() => onDelete(file)}
            >
              <IconTrash size={16} />
            </ActionIcon>
          )}
        </Group>
      ))}
    </Stack>
  )
}
